const CLIENT_STATUS_ROLES = new Set(['OWNER', 'ADMIN', 'OFFICE', 'REFERRAL_COORDINATOR']);

export function canManageClientStatus(role: string | null | undefined): boolean {
  return CLIENT_STATUS_ROLES.has(String(role || '').trim().toUpperCase());
}
